import { FC, useEffect } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { TPgLegalEntity } from 'services/api/paymentGateway/types';

type TLegalEntitySelectProps = {
	legalEntities: TPgLegalEntity[] | null;
	value: number | null;
	onChange: (legalEntityId: number) => void;
	disabled?: boolean;
	label?: string;
};

/**
 * Legal entity picker of the settings tabs. Selects the default legal entity once the list arrives
 * (EAS works with one legal entity for now, the model supports several).
 */
export const LegalEntitySelect: FC<TLegalEntitySelectProps> = ({
	legalEntities,
	value,
	onChange,
	disabled,
	label = 'Legal entity',
}) => {
	useEffect(() => {
		if (value !== null || !legalEntities?.length) return;
		const preferred = legalEntities.find((e) => e.isDefault) ?? legalEntities[0];
		onChange(preferred.id);
	}, [legalEntities, value, onChange]);

	return (
		<TextField
			select
			size="small"
			label={label}
			value={value ?? ''}
			onChange={(event) => onChange(Number(event.target.value))}
			disabled={disabled || !legalEntities?.length}
			sx={{ minWidth: 260, backgroundColor: 'background.paper' }}
		>
			{(legalEntities ?? []).map((entity) => (
				<MenuItem key={entity.id} value={entity.id}>
					{entity.name} ({entity.code}){entity.isDefault ? ' — default' : ''}
					{entity.isActive ? '' : ' — inactive'}
				</MenuItem>
			))}
		</TextField>
	);
};
